import {SectionIntro} from '@primer/react-brand'
import Styles from './SectionHeader.module.css'

export interface SectionHeaderProps {
  heading: string
  body?: string
}

export const SectionHeader = ({heading, body}: SectionHeaderProps) => {
  return (
    <section className={Styles['SectionHeader']}>
      <SectionIntro align="center" fullWidth>
        <SectionIntro.Heading as="h2" size="3">
          {heading}
        </SectionIntro.Heading>
        {body && <SectionIntro.Description className={Styles['SectionHeader__body']}>{body}</SectionIntro.Description>}
      </SectionIntro>
    </section>
  )
}
